import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./NudgesNewM.css";
import { ITEMS_PER_PAGE } from "./nudgesUtils";
import NudgeFilterBar from "./NudgeFilterBar";
import NudgeCard from "./NudgeCard";
import Pagination from "./Pagination";
import { submitNudgesNewRequest } from "../../../../../store/features/actions/NudgesNewActions";
import GenericOverviewSideCard from "../../../genericComponents/GenericOverviewSideCard";
import BattleCard from "../../Opportunities/CardTabs/BattleCard";
import SideCardHorizntalTabComp from "../../../genericComponents/sideCardHorizontalTabs/SideCardHorizntalTabComp";
import ScHeaderComp from "../../../genericComponents/genericTableComp/genericTableScHeader/ScHeaderComp";
import PlainModal from "../../../../HtmlElements/PlainModal";
import BattleCardV2 from "../../Opportunities/CardTabs/BattleCardV2";

const randomIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" className="top_tab_icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#535458" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
);

export default function NudgesNewM({ active_tab_key }) {

const [, setSearchParams] = useSearchParams();
  useEffect(() => {
        setSearchParams({
          tab: "nudges_new",
        });
  }, []);
  const { clientName, accountName } = useParams();
  const dispatch = useDispatch();
  const { loading, successMessage } = useSelector(
    (state) => state?.nudgesNewReducer
  );
  const [activeTab, setActiveTab] = useState("");
  const [filterList, setFilterList] = useState([]);
  const [filteredOpportunities, setFilteredOpportunities] = useState([]);
  const [filteredNudges, setFilteredNudges] = useState([]);
  const [showMoreModal, setShowMoreModal] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedOpportunity, setSelectedOpportunity] = useState({
    id: null,
    name: null,
    desc: null,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const commonProps = useMemo(
    () => ({
      opportunityId: selectedOpportunity.id,
      opportunityName: selectedOpportunity.name,
      opportunityDescription: selectedOpportunity.desc,
    }),
    [selectedOpportunity]
  );
  const tabConfig = useMemo(
    () => [
      {
        key: "battle_card_nudge",
        label: "Battle Card",
        Component: () => <BattleCardV2 opportunityId={commonProps?.opportunityId} />,
        icon: randomIcon,
        tagIcon: <img src="/img/blueDocIcon.png" width="16" />,
      },
    ],
    [commonProps]
  );

  useEffect(() => {
    dispatch(submitNudgesNewRequest({ clientName, accountName }));
  }, [accountName]);

  useEffect(() => {
    if (successMessage?.length) {
      const filters = [
        ...new Set(successMessage.map((item) => item.opportunity_category)),
      ];
      setFilterList(filters);
      setFilteredOpportunities(filters);
      // setFilteredOpportunities(filters.slice(0, 2));
    }
  }, [successMessage]);

  useEffect(() => {
    if (successMessage) {
      const filtered = successMessage.filter((item) =>
        filteredOpportunities.includes(item.opportunity_category)
      );
      const newlyFilterd = filtered.filter(record =>
        record.opportunity_name.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredNudges(newlyFilterd);
      // setFilteredNudges(filtered);
      setCurrentPage(1);
    }
  }, [filteredOpportunities, successMessage, searchTerm]);

  const paginatedNudges = filteredNudges.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const totalPages = Math.ceil(filteredNudges.length / ITEMS_PER_PAGE);

  const handleSideCard = useCallback((e, nudge, tabId = "battle_card_nudge") => {
    // console.log("nudge",nudge)
    e.preventDefault();
    e.stopPropagation();
    setShowMoreModal(true);
    setSelectedOpportunity({
      id: nudge?._id,
      name: nudge?.opportunity_name,
      desc: nudge?.opportunity_description,
    });
    setActiveTab(tabId);
  }, []);

  const[showDetailModal, setShowDetailModal] = useState(false);
  const[nthNudge, setNthNudge] = useState(0);
  const handleMore = (newindex) => {
    setShowDetailModal(true);
    setNthNudge(newindex);
  };

  const handleClose = () => {
    setShowDetailModal(false);
    setNthNudge(0);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  }

  return (
    <>
      <div className="nudges_new_wrapper ">
        <div className="know_whats_block">
          <h5 className="know_whats_head">
            Know what’s changed — live nudges from news, signals, and shifts.
          </h5>

          <NudgeFilterBar
            filterList={filterList}
            filteredOpportunities={filteredOpportunities}
            setFilteredOpportunities={setFilteredOpportunities}
            successMessage={successMessage}
          />
        </div>
        <div className="nudges_new_block ">
          <div className="row">
            <div className="col-md-6 d-inline-block"></div>
            <div className="col-md-6 d-inline-block float-end">
              <input
                type="text"
                className="form-control float-end"
                placeholder="Search..."
                style={{
                    width: "350px",
                    height: "32px",
                    padding: "8px 4px 8px 4px",
                    border: "0.5px solid #42464847",
                    backgroundColor: "#FFFFFF",
                    fontSize: "12.5px",
                    lineHeight: "15.63px",
                    fontWeight: "500",
                    color: "#9595A1"
                }}
                value={searchTerm}
                onChange={(e) => handleSearch(e)}
              />
            </div>
          </div>
          <div className="row">
          {paginatedNudges.length ? (
            paginatedNudges.map((nudge, index) => (
              <div
                className="col-md-6 pt-4"
                key={index}
                // onClick={(e) => handleSideCard(e, nudge)}
              >
                <NudgeCard nudge={nudge} handleSideCard={handleSideCard} index={index} handleMore={handleMore} />
              </div>
            ))
          ) : (
            <div className="text-center">Select a filter to show nudges</div>
          )}
        </div>
        </div>

        {totalPages > 1 && (
          <Pagination
            totalPages={totalPages}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
          />
        )}
      </div>
      {showDetailModal &&
        <PlainModal
          title={paginatedNudges?.[nthNudge]?.opportunity_name}
          text={paginatedNudges?.[nthNudge]?.opportunity_description}
          handleClose={handleClose}
        />}
      <GenericOverviewSideCard
        showMoreModal={showMoreModal}
        setShowMoreModal={setShowMoreModal}
        titleForSideCard={
          <ScHeaderComp
            key={`side_card_head_comp_${commonProps?.opportunityId}`} 
            type="nudges"
            showMoreModal={showMoreModal} 
            titlTxt={selectedOpportunity.name}  
            setShowMoreModal={setShowMoreModal} 
            opportunityId={commonProps?.opportunityId}
          />}
        comp={
          <SideCardHorizntalTabComp
            tabConfig={tabConfig}
            setShowMoreModal={setShowMoreModal}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        }
        disableXbtn
      />
    </>
  );
}
